<template>
  <div style="max-width:430px;margin:0 auto;background:#f7f8fa;min-height:100vh;padding-bottom:80px;">
    <div style="height:56px;display:flex;align-items:center;justify-content:center;background:#fff;box-shadow:0 1px 0 #f0f0f0;position:relative;">
      <span style="position:absolute;left:0;top:0;height:56px;display:flex;align-items:center;font-size:26px;padding:0 16px;cursor:pointer;" @click="$router.push('/profile')">&#8592;</span>
      <span style="font-size:20px;font-weight:bold;letter-spacing:1px;">账户充值</span>
    </div>
    <div style="background:#fff;border-radius:16px;margin:24px 16px 0;padding:18px 0;box-shadow:0 2px 8px #f0f0f0;text-align:center;">
      <div style="font-size:16px;color:#888;">账户余额</div>
      <div style="font-size:32px;color:#222;font-weight:bold;margin:8px 0;">{{ displayBalance }}</div>
    </div>
    <div style="margin:32px 16px 0;">
      <div style="font-size:17px;color:#222;font-weight:500;margin-bottom:12px;">选择充值金额</div>
      <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:16px 12px;">
        <button :class="['recharge-amount-btn', sel===100 && 'selected']" type="button" @click="choose(100)">￥100</button>
        <button :class="['recharge-amount-btn', sel===500 && 'selected']" type="button" @click="choose(500)">￥500</button>
        <button :class="['recharge-amount-btn', sel===1000 && 'selected']" type="button" @click="choose(1000)">￥1000</button>
        <button :class="['recharge-amount-btn', sel===2000 && 'selected']" type="button" @click="choose(2000)">￥2000</button>
        <button :class="['recharge-amount-btn', sel===5000 && 'selected']" type="button" @click="choose(5000)">￥5000</button>
        <button :class="['recharge-amount-btn', sel==='custom' && 'selected']" id="recharge-custom-btn" type="button" @click="choose('custom')" style="border:2px dashed #238aff;color:#238aff;background:#fff;">自定义金额</button>
      </div>
      <input v-show="sel==='custom'" v-model.number="custom" type="number" min="1" placeholder="请输入自定义金额" style="width:90%;margin-top:12px;background:#f7f8fa;border:1.5px solid #238aff;border-radius:10px;padding:12px 16px;font-size:17px;color:#222;outline:none;">
    </div>
    <div style="margin:32px 16px 0;">
      <div style="font-size:17px;color:#222;font-weight:500;margin-bottom:12px;">选择支付方式</div>
      <div style="background:#fff;border-radius:12px;padding:16px 0 0;box-shadow:0 2px 8px #f0f0f0;">
        <div :class="['pay-method-row', pay==='online' && 'selected']" @click="pay='online'">
          <div class="pay-method-info"><span class="pay-method-title">在线支付</span><span class="pay-method-desc">支持微信</span></div>
          <span class="pay-radio"><span class="pay-radio-dot" v-show="pay==='online'"></span></span>
        </div>
        <div :class="['pay-method-row', pay==='bank' && 'selected']" @click="pay='bank'">
          <div class="pay-method-info"><span class="pay-method-title">对公转账</span><span class="pay-method-desc">支持银行转账</span></div>
          <span class="pay-radio"><span class="pay-radio-dot" v-show="pay==='bank'"></span></span>
        </div>
      </div>
    </div>
    <div style="margin:38px 16px 0;">
      <button id="recharge-confirm-btn" type="button" style="width:160px;background:#4caf50;color:#fff;font-size:22px;font-weight:bold;border:none;border-radius:30px;padding:3px 0;display:block;margin:0 auto;" @click="confirm">确认充值</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { formatBalance } from '@/utils/user'
import { getBusinessByUser, createRechargeRecordAndPayment, createMerchantRechargeRecord } from '@/api/business'
import request from '@/utils/request'

export default {
  name: 'RechargePage',
  data () { return { sel: null, custom: null, pay: 'online', businessId: null, businessName: '', parkingLotId: null, parkingLotName: '', parkingMap: {}, operatorId: null, operatorName: '', submitting: false, lastRechargeAmount: null } },
  computed: {
    ...mapGetters(['balance']),
    displayBalance () { return formatBalance(this.balance) },
    selectedAmount () {
      if (this.sel === 'custom') return Number(this.custom) || 0
      return Number(this.sel) || 0
    }
  },
  async mounted () {
    // 初始化 businessId：优先用路由查询参数，其次 localStorage.currentBusiness，再次按 userId 查询
    // 注意：微信授权回调已在登录页面（Login.vue）处理，openId 已保存到 localStorage
    // 充值页面只需要从 localStorage 读取 openId 即可，无需再次处理回调
    try {
      const qId = this.$route && this.$route.query ? (this.$route.query.businessId || null) : null
      const qName = this.$route && this.$route.query ? (this.$route.query.businessName || null) : null
      const qOpId = this.$route && this.$route.query ? (this.$route.query.operatorId || null) : null
      const qOpName = this.$route && this.$route.query ? (this.$route.query.operatorName || null) : null
      if (qId) {
        this.businessId = qId
        if (qName) this.businessName = qName
        if (qOpId) this.operatorId = qOpId
        if (qOpName) this.operatorName = qOpName
        // 继续尝试解析停车场
        await this.resolveParkingInfo()
        return
      }
      try {
        const cached = localStorage.getItem('currentBusiness')
        if (cached) {
          const biz = JSON.parse(cached)
          const bid = biz && (biz.businessId || biz.id)
          const bname = biz && (biz.businessName || biz.name)
          const parkIds = biz && (biz.parkIds || biz.parkingIds || [])
          if (bid) {
            this.businessId = bid
            this.businessName = bname || this.businessName
            if (Array.isArray(parkIds) && parkIds.length) {
              this.parkingLotId = parkIds[0]
            }
            await this.resolveParkingInfo()
            return
          }
        }
      } catch (e) { /* ignore */ }

      let uid = localStorage.getItem('userId')
      if (!uid) {
        const tk = localStorage.getItem('token')
        try {
          const parts = (tk || '').split('.')
          if (parts.length === 3) {
            const payload = JSON.parse(atob(parts[1]))
            uid = payload.userId || payload.uid || payload.sub || null
          }
        } catch (e) { /* ignore */ }
      }
      
      if (!uid) {
        console.warn('无法获取用户ID，无法查询商户信息')
        return
      }
      
      console.log('开始获取商户信息，userId:', uid)
      try {
        const resp = await getBusinessByUser(uid)
        console.log('getBusinessByUser 完整响应:', JSON.stringify(resp, null, 2))
        
        // 处理响应数据结构
        // MyApiResponse 结构: { code: 200, message: "成功", data: BusinessDTO }
        let biz = null
        if (resp) {
          // 方式1: 标准 MyApiResponse 结构
          if (resp.code === 200 && resp.data) {
            biz = resp.data
          }
          // 方式2: 直接是 data 字段
          else if (resp.data) {
            if (resp.data.businessId || resp.data.id) {
              biz = resp.data
            } else if (resp.data.data && (resp.data.data.businessId || resp.data.data.id)) {
              biz = resp.data.data
            }
          }
          // 方式3: 直接是 BusinessDTO
          else if (resp.businessId || resp.id) {
            biz = resp
          }
        }
        
        console.log('解析后的商户信息:', biz)
        
        if (biz && (biz.businessId || biz.id)) {
          this.businessId = biz.businessId || biz.id
          this.businessName = biz.businessName || biz.name || this.businessName || ''
          const parkIds = biz.parkIds || biz.parkingIds || []
          if (Array.isArray(parkIds) && parkIds.length) {
            this.parkingLotId = parkIds[0]
          }
          // 保存到 localStorage 以便后续使用
          try {
            localStorage.setItem('currentBusiness', JSON.stringify(biz))
            console.log('商户信息已保存到 localStorage')
          } catch (e) {
            console.warn('保存商户信息到 localStorage 失败:', e)
          }
        } else {
          console.warn('未获取到商户信息')
          console.warn('响应 code:', resp?.code)
          console.warn('响应 message:', resp?.message)
          console.warn('响应 data:', resp?.data)
          // 如果接口返回成功但没有数据，说明用户没有关联的商户
          if (resp && resp.code === 200 && (resp.data === null || resp.data === undefined)) {
            console.warn('用户没有关联的商户，userId:', uid)
            // 显示友好的提示信息
            alert('您当前没有关联的商户，请联系管理员为您分配商户权限')
          } else if (resp && resp.code !== 200) {
            console.error('接口返回错误:', resp.message || '未知错误')
            alert('获取商户信息失败: ' + (resp.message || '未知错误'))
          }
        }
      } catch (error) {
        console.error('获取商户信息异常:', error)
        console.error('错误详情:', error.response || error.message)
      }

      // 操作人（兜底从本地与token解析）
      if (!this.operatorId) {
        this.operatorId = localStorage.getItem('userId') || null
        if (!this.operatorId) {
          const tk = localStorage.getItem('token')
          try {
            const parts = (tk || '').split('.')
            if (parts.length === 3) {
              const payload = JSON.parse(atob(parts[1]))
              this.operatorId = payload.userId || payload.uid || payload.sub || null
              this.operatorName = this.operatorName || payload.realName || payload.username || payload.userName || ''
            }
          } catch (e) { /* ignore */ }
        }
      }

      await this.resolveParkingInfo()
    } catch (e) {
      console.warn('获取商户信息失败：', e)
    }
  },
  methods: {
    ...mapActions(['FetchMerchantBalance']),
    choose (v) { this.sel = v },
    // 参照 Coupon.vue：根据管理员查询商户→聚合或定向取 parkIds→按ID列表查询停车场→确定 parkingLotId/name
    async resolveParkingInfo () {
      try {
        // 1) 获取管理员 userId
        let userId = localStorage.getItem('userId')
        if (!userId) {
          const tk = localStorage.getItem('token')
          if (tk) {
            try {
              const parts = tk.split('.')
              if (parts.length === 3) {
                const payload = JSON.parse(atob(parts[1]))
                userId = payload.userId || payload.uid || payload.sub || null
              }
            } catch (e) { /* ignore */ }
          }
        }
        // 2) 拉取商户列表（按管理员筛选）
        let merchantList = []
        if (userId) {
          const merchantRes = await request({
            url: '/market/business/list',
            method: 'post',
            data: { administor: userId },
            timeout: 30000
          })
          merchantList = merchantRes?.data || []
        }
        // 3) 优先用当前 businessId 对应的 parkIds
        let targetParkIds = []
        if (this.businessId) {
          const m = merchantList.find(x => (x.businessId === this.businessId))
          if (m && Array.isArray(m.parkIds) && m.parkIds.length) {
            targetParkIds = m.parkIds
          }
        }
        // 4) 若没有，聚合全部 parkIds
        if (!targetParkIds.length) {
          merchantList.forEach(m => {
            if (Array.isArray(m?.parkIds)) targetParkIds.push(...m.parkIds)
          })
        }
        targetParkIds = [...new Set(targetParkIds)].filter(Boolean)
        if (!targetParkIds.length) return

        // 5) 批量按ID获取停车场详情
        const parkingRes = await request({
          url: '/parking/info/list/by-ids',
          method: 'post',
          data: targetParkIds,
          timeout: 30000
        })
        const parkingList = parkingRes?.data || []
        const map = {}
        parkingList.forEach(item => {
          if (!item) return
          const id = item.parkingId || item.id || item.parkingCode
          const name = item.parkingName || item.name
          if (id && name) map[id] = name
        })
        this.parkingMap = map

        // 6) 选取 parkingLotId：优先已存在的；否则使用第一个
        if (!this.parkingLotId) {
          this.parkingLotId = targetParkIds.find(id => !!map[id]) || targetParkIds[0]
        }
        if (this.parkingLotId && map[this.parkingLotId]) {
          this.parkingLotName = map[this.parkingLotId]
        }
      } catch (e) {
        console.warn('解析停车场信息失败:', e)
      }
    },
    // 格式化为 LocalDateTime (YYYY-MM-DD HH:mm:ss)
    formatToLocalDateTime (date) {
      const d = date instanceof Date ? date : new Date(date)
      const p = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
    },
    // 获取操作人UUID
    getOperatorIdUuid () {
      const fromStore = this.$store && this.$store.state && this.$store.state.user && this.$store.state.user.id
      const isUuid = v => typeof v === 'string' && /^[0-9a-fA-F-]{36}$/.test(v)
      if (isUuid(fromStore)) return fromStore
      const fromLocal = localStorage.getItem('userId')
      if (isUuid(fromLocal)) return fromLocal
      try {
        const tk = localStorage.getItem('token')
        const parts = (tk || '').split('.')
        if (parts.length === 3) {
          const payload = JSON.parse(atob(parts[1]))
          const cand = payload.userId || payload.uid || payload.sub || ''
          if (isUuid(cand)) return cand
        }
      } catch (e) { /* ignore */ }
      return null
    },
    // 操作人名称兜底
    getOperatorNameFallback () {
      try {
        const tk = localStorage.getItem('token')
        const parts = (tk || '').split('.')
        if (parts.length === 3) {
          const payload = JSON.parse(atob(parts[1]))
          return payload.realName || payload.username || payload.userName || ''
        }
      } catch (e) { /* ignore */ }
      return ''
    },
    // 创建充值记录
    async createRechargeRecord () {
      if (!this.lastRechargeAmount || !this.businessId) {
        console.warn('无法创建充值记录：缺少充值金额或商户ID')
        return
      }
      
      try {
        const payload = {
          businessId: this.businessId,
          businessName: this.businessName || '',
          parkingLotId: this.parkingLotId || null,
          parkingLotName: this.parkingLotName || '',
          accountType: '储值账户',
          rechargeAmount: Number(this.lastRechargeAmount),
          actualPayment: Number(this.lastRechargeAmount),
          giftAmount: 0,
          rechargeType: 'ONLINE',
          isPublicAccount: false,
          payWay: 'WECHAT',
          payChannel: 'H5_SCAN_CODE',
          status: 'PAID',
          invoiceStatus: 'NOT_INVOICED',
          autoRecharge: false,
          autoClear: false,
          rechargeTime: this.formatToLocalDateTime(new Date()),
          operatorId: this.getOperatorIdUuid(),
          operatorName: this.operatorName || this.$store?.state?.user?.name || this.getOperatorNameFallback(),
          remark: 'H5页面在线充值-账户余额充值'
        }
        
        await createMerchantRechargeRecord(payload)
        console.log('创建充值记录成功')
      } catch (err) {
        console.error('创建充值记录失败:', err)
        // 不显示错误提示，避免影响用户体验
      }
    },

    // 调用微信支付
    callWechatPay (paymentInfo) {
      // 方式1: 使用 jweixin (如果已引入)
      // eslint-disable-next-line no-undef
      if (typeof wx !== 'undefined' && wx.chooseWXPay) {
        // eslint-disable-next-line no-undef
        wx.chooseWXPay({
          appId: paymentInfo.appId,
          timestamp: paymentInfo.timeStamp,
          nonceStr: paymentInfo.nonceStr,
          package: paymentInfo.package,
          signType: paymentInfo.signType,
          paySign: paymentInfo.paySign,
          success: async (res) => {
            console.log('微信支付成功:', res)
            alert('支付成功')
            // 刷新余额
            this.FetchMerchantBalance().catch(e => console.warn('刷新余额失败', e))
            
            // 创建充值记录
            await this.createRechargeRecord()
            
            this.custom = null
            this.sel = null
            // 可选：跳转到成功页面或返回上一页
            setTimeout(() => {
              this.$router.push('/profile')
            }, 1500)
          },
          fail: (res) => {
            console.error('微信支付失败:', res)
            if (res.errMsg && res.errMsg.includes('cancel')) {
              alert('支付已取消')
            } else {
              alert('支付失败: ' + (res.errMsg || '未知错误'))
            }
          },
          cancel: (res) => {
            console.log('用户取消支付:', res)
            alert('支付已取消')
          }
        })
        return
      }

      // 方式2: 使用 WeixinJSBridge (微信内置浏览器)
      // eslint-disable-next-line no-undef
      if (typeof WeixinJSBridge !== 'undefined') {
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            appId: paymentInfo.appId,
            timeStamp: paymentInfo.timeStamp,
            nonceStr: paymentInfo.nonceStr,
            package: paymentInfo.package,
            signType: paymentInfo.signType,
            paySign: paymentInfo.paySign
          },
          async (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              console.log('微信支付成功:', res)
              alert('支付成功')
              this.FetchMerchantBalance().catch(e => console.warn('刷新余额失败', e))
              
              // 创建充值记录
              await this.createRechargeRecord()
              
              this.custom = null
              this.sel = null
              setTimeout(() => {
                this.$router.push('/profile')
              }, 1500)
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
              console.log('用户取消支付:', res)
              alert('支付已取消')
            } else {
              console.error('微信支付失败:', res)
              alert('支付失败: ' + (res.err_msg || '未知错误'))
            }
          }
        )
        return
      }

      // 方式3: 等待 WeixinJSBridge 就绪
      if (typeof document !== 'undefined') {
        const self = this
        const tryPay = () => {
          // eslint-disable-next-line no-undef
          if (typeof WeixinJSBridge !== 'undefined') {
            self.callWechatPay(paymentInfo)
          }
        }
        
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', tryPay, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', tryPay)
          document.attachEvent('onWeixinJSBridgeReady', tryPay)
        }
        
        // 如果3秒后还没就绪，提示用户
        setTimeout(() => {
          // eslint-disable-next-line no-undef
          if (typeof WeixinJSBridge === 'undefined' && typeof wx === 'undefined') {
            alert('请在微信环境中打开此页面进行支付')
            console.warn('微信支付环境未就绪，paymentInfo:', paymentInfo)
          }
        }, 3000)
        return
      }

      // 如果都不支持，提示用户
      alert('请在微信环境中打开此页面进行支付')
      console.warn('微信支付环境未就绪，paymentInfo:', paymentInfo)
    },

    async confirm () {
      const amount = this.sel === 'custom' ? Number(this.custom) : this.sel
      if (!amount || amount <= 0) return alert('请选择或输入充值金额')
      if (!this.pay) return alert('请选择支付方式')
      if (this.pay === 'bank') return this.$router.push('/transfer')
      
      // 如果 businessId 为空，尝试重新获取
      if (!this.businessId) {
        console.warn('businessId 为空，尝试重新获取商户信息')
        try {
          let uid = localStorage.getItem('userId')
          if (!uid) {
            const tk = localStorage.getItem('token')
            try {
              const parts = (tk || '').split('.')
              if (parts.length === 3) {
                const payload = JSON.parse(atob(parts[1]))
                uid = payload.userId || payload.uid || payload.sub || null
              }
            } catch (e) { /* ignore */ }
          }
          
          if (uid) {
            try {
              const resp = await getBusinessByUser(uid)
              console.log('重新获取商户信息响应:', resp)
              
              // 处理响应数据结构
              let biz = null
              if (resp) {
                // 标准 MyApiResponse 结构
                if (resp.code === 200 && resp.data) {
                  biz = resp.data
                }
                // 其他可能的格式
                else if (resp.data) {
                  if (resp.data.businessId || resp.data.id) {
                    biz = resp.data
                  } else if (resp.data.data && (resp.data.data.businessId || resp.data.data.id)) {
                    biz = resp.data.data
                  }
                } else if (resp.businessId || resp.id) {
                  biz = resp
                }
              }
              
              if (biz && (biz.businessId || biz.id)) {
                this.businessId = biz.businessId || biz.id
                this.businessName = biz.businessName || biz.name || ''
                // 保存到 localStorage
                try {
                  localStorage.setItem('currentBusiness', JSON.stringify(biz))
                } catch (e) {
                  console.warn('保存商户信息失败:', e)
                }
              } else {
                console.warn('重新获取商户信息失败，响应:', resp)
              }
            } catch (e) {
              console.error('重新获取商户信息异常:', e)
            }
          }
        } catch (e) {
          console.error('重新获取商户信息失败:', e)
        }
      }
      
      if (!this.businessId) {
        // 尝试从 localStorage 获取缓存的商户信息
        try {
          const cached = localStorage.getItem('currentBusiness')
          if (cached) {
            const biz = JSON.parse(cached)
            const bid = biz && (biz.businessId || biz.id)
            if (bid) {
              console.log('从 localStorage 恢复商户信息:', bid)
              this.businessId = bid
              this.businessName = biz.businessName || biz.name || ''
            }
          }
        } catch (e) {
          console.warn('从 localStorage 恢复商户信息失败:', e)
        }
      }
      
      if (!this.businessId) {
        alert('未获取到商户信息，可能的原因：\n1. 您当前没有关联的商户\n2. 网络连接问题\n\n请稍后重试或联系管理员为您分配商户权限')
        return
      }

      if (this.submitting) return
      this.submitting = true

      // 保存充值金额，用于支付成功后创建充值记录
      this.lastRechargeAmount = amount

      try {
        // 1. 从 localStorage 获取 openId（微信授权回调已在登录页面处理，openId 已保存）
        // 优先从 localStorage 获取，如果没有则从 sessionStorage 获取（登录页面可能保存到 sessionStorage）
        let openId = localStorage.getItem('wx_open_id')
        if (!openId) {
          openId = sessionStorage.getItem('wx_open_id')
          // 如果从 sessionStorage 获取到，也保存到 localStorage 以便后续使用
          if (openId) {
            localStorage.setItem('wx_open_id', openId)
            console.log('📝 [Recharge] 从 sessionStorage 获取到 openId 并保存到 localStorage')
          }
        }
        
        if (openId) {
          console.log('✅ [Recharge] 从存储中获取到 openId:', openId.substring(0, 10) + '...')
        } else {
          console.warn('⚠️ [Recharge] 存储中未找到 openId，可能影响微信支付')
          console.warn('  - 提示：微信授权回调应在登录页面处理，openId 会自动保存')
        }
        
        // 2. 构建请求参数：businessId, amount, payChannel, openId
        const requestData = {
          businessId: this.businessId,
          amount: amount,
          payChannel: 'H5_SCAN_CODE' // 必填：支付渠道
        }
        
        // 如果有 openId，添加到请求中
        if (openId) {
          requestData.openId = openId
        }
        
        // orderType 可选，后端默认 MERCHANTRE_CHARGE_FEE
        // attach 可选

        console.log('创建充值订单请求:', {
          ...requestData,
          openId: openId ? openId.substring(0, 10) + '...' : '未提供'
        })

        // 调用接口创建充值记录并生成支付订单
        const response = await createRechargeRecordAndPayment(requestData)

        if (response && response.code === 200) {
          const { cashFlowId, orderId, paymentInfo } = response.data

          console.log('创建充值订单成功:', { cashFlowId, orderId, paymentInfo })

          // 调用微信支付
          if (paymentInfo) {
            this.callWechatPay(paymentInfo)
          } else {
            alert('创建充值订单成功，但未获取到支付信息')
          }
        } else {
          const errorMsg = response?.message || '创建充值订单失败'
          alert(errorMsg)
        }
      } catch (error) {
        console.error('创建充值订单失败:', error)
        alert(error?.message || '创建充值订单失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.recharge-amount-btn {
  background:#eaf3ff;
  color:#238aff;
  font-size:20px;
  font-weight:bold;
  border:none;
  border-radius:12px;
  padding:16px 0;
  transition:all 0.2s;
}

.recharge-amount-btn.selected {
  background:#238aff;
  color:#fff;
  border:2px solid #238aff;
}

.pay-method-row {
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:12px 16px;
  cursor:pointer;
  background:#fff;
  border-radius:8px;
  margin-bottom:8px;
  transition: background .2s;
}

.pay-method-row.selected {
  background:#eaf3ff;
}

.pay-method-info {
  display:flex;
  flex-direction:column;
  align-items:flex-start;
}

.pay-method-title {
  font-size:17px;
  color:#222;
}

.pay-method-desc {
  font-size:15px;
  color:#888;
  margin-top:4px;
}

.pay-radio {
  width:22px;
  height:22px;
  border-radius:50%;
  border:2px solid #238aff;
  background:#fff;
  display:flex;
  align-items:center;
  justify-content:center;
}

.pay-radio-dot {
  width:10px;
  height:10px;
  border-radius:50%;
  background:#238aff;
}
</style>
